// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Hide tinymce-react Regist-Info*/\r\n.tox-notifications-container {\r\n  display: none;\r\n}\r\n\r\n.tox-statusbar__branding {\r\n  display: none;\r\n}", ""]);
// Exports
module.exports = exports;
